import { Trans, useLingui } from '@lingui/react/macro';
import { Stack } from '@mui/material';
import { TOGGLEABLE_TERMINAL_PANEL_IDS, type ToggleableTerminalPanelId } from '@/common/terminalLayout.ts';
import { useUiStore } from '@/common/uiStore.ts';
import { PreferenceSection } from './preference_section.tsx';
import { PreferenceSwitch } from './preference_switch.tsx';

const panelLabels: Record<ToggleableTerminalPanelId, React.ReactNode> = {
  favorites: <Trans comment="Preferences: trading panel toggle">Favorites</Trans>,
  market: (
    <Trans
      context="terminal panel"
      comment="Preferences: trading panel toggle. Names the market-info panel (ticker, 24h change, funding, open interest) — the market itself, not the market order type that the uncontexted 'Market' translates."
    >
      Market
    </Trans>
  ),
  orderBook: <Trans comment="Preferences: trading panel toggle">Order Book</Trans>,
  accountStatus: <Trans comment="Preferences: trading panel toggle">Account Status</Trans>,
};

export function TerminalPanelsSection() {
  const { t } = useLingui();
  const terminalPanels = useUiStore((state) => state.terminalPanels);
  const setTerminalPanelVisible = useUiStore((state) => state.setTerminalPanelVisible);

  return (
    <PreferenceSection title={t({ comment: 'Preferences: trading panels section title', message: 'Trading Panels' })}>
      <Stack gap={1}>
        {TOGGLEABLE_TERMINAL_PANEL_IDS.map((panelId) => (
          <PreferenceSwitch
            key={panelId}
            label={panelLabels[panelId]}
            checked={terminalPanels[panelId]}
            onChange={(checked) => setTerminalPanelVisible(panelId, checked)}
          />
        ))}
      </Stack>
    </PreferenceSection>
  );
}
